// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1tDFY","log":"ModalInventoryLogs_log__1ke01","date":"ModalInventoryLogs_date__2K3Q3","userName":"ModalInventoryLogs_userName__3tuVN"};